webpackJsonp([6397908637709],{

/***/ 431:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>Hepatitis C is a virus that can infect the liver. If left untreated, it can sometimes cause serious and potentially life-threatening damage to the liver over many years.</p>\n<p>However, with modern treatments it's usually possible to cure the infection, and most people with it will have a normal life expectancy.</p>\n<p>It's estimated around 215,000 people in the UK have hepatitis C.</p>\n<p>You can become infected with it if you come into contact with the blood of an infected person.</p>\n<p><a href=\"https://www.nhs.uk/conditions/hepatitis-c/\">via National Health Service UK</a></p>","frontmatter":{"path":"nhs-overview","title":"Hepatitis C infection (HCV) overview (NHS)","date":"2018-05-11","tags":["hepatitis","infection","cirrhosis"]}}},"pathContext":{"slug":"nhs-overview"}}

/***/ })

});


// WEBPACK FOOTER //
// path---article-nhs-overview-f6b07acc8a533222ccc4.js